import { EnvMicroRequirement } from "lib-klab-core";

export const envRequirementLocal: EnvMicroRequirement = {
  host: "",
  apiBasePath: "/ms-requirement",
  enabled: true,
  useMocks: false,
};

export const envRequirementDev: EnvMicroRequirement = {
  host: "https://gatewayapi-dev.erp.inclub.world",
  apiBasePath: "/ms-requirement",
  enabled: true,
  useMocks: false,
};

export const envRequirementProd: EnvMicroRequirement = {
  host: "",
  apiBasePath: "/ms-requirement",
  enabled: true,
  useMocks: false,
};
